import * as tslib_1 from "tslib";
import * as React from 'react';
import { List, ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
var styles = {
    item: {
        fontSize: '13px'
    }
};
var ProjectList = /** @class */ (function (_super) {
    tslib_1.__extends(ProjectList, _super);
    function ProjectList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelection = function (e, project) {
            e.preventDefault();
            _this.props.onSelection(project);
        };
        return _this;
    }
    ProjectList.prototype.render = function () {
        var _this = this;
        var items = this.props.items.map(function (i) {
            return React.createElement("div", { key: i.id },
                React.createElement(ListItem, { onClick: function (e) { return _this.handleSelection(e, i); }, style: styles.item }, i.name),
                React.createElement(Divider, null));
        });
        return React.createElement(List, null, items);
    };
    return ProjectList;
}(React.Component));
export { ProjectList };



//////////////////
// WEBPACK FOOTER
// ./src/pages/statistics/ProjectList.tsx
// module id = 797
// module chunks = 0